const resetPasswordStyle = theme => ({
    page: {
        minHeight: "100vh",
        position: "relative",
        background: "#eef2f7",
        color: "#263a59",
        overflow: "hidden",
    },
    hero: {
        position: "relative",
        height: "245px",
        margin: "48px 10px 0",
        borderRadius: "0 0 8px 8px",
        overflow: "hidden",
        backgroundImage: "url('/media/bg-rental.cbe4acac21b9d2d5d2bf.jpeg')",
        backgroundPosition: "center 35%",
        backgroundSize: "cover",
        [theme.breakpoints.down("sm")]: {
            height: "230px",
            marginTop: "24px",
        },
    },
    heroOverlay: {
        position: "absolute",
        inset: 0,
        background: "rgba(8, 20, 34, 0.58)",
    },
    brandWrap: {
        position: "relative",
        zIndex: 1,
        width: "72%",
        maxWidth: "1020px",
        minWidth: "720px",
        margin: "0 auto",
        paddingTop: "22px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 32px)",
            minWidth: "unset",
        },
    },
    logo: {
        width: "76px",
        height: "40px",
        objectFit: "contain",
        background: "#fff",
    },
    logoLink: {
        display: "inline-flex",
        lineHeight: 0,
        cursor: "pointer",
    },
    brandText: {
        fontSize: "13px",
        fontWeight: 700,
        color: "#fff",
    },
    resetShell: {
        position: "relative",
        zIndex: 2,
        width: "376px",
        margin: "-108px auto 0",
        borderRadius: "8px",
        background: "#fff",
        boxShadow: "0 2px 8px rgba(18, 38, 63, 0.16)",
        [theme.breakpoints.down("xs")]: {
            width: "calc(100% - 32px)",
        },
    },
    form: {
        margin: 0,
    },
    cardHeader: {
        width: "calc(100% - 28px)",
        margin: "0 auto",
        transform: "translateY(-20px)",
        padding: "25px 16px 18px",
        borderRadius: "6px",
        color: "#fff",
        textAlign: "center",
        background: "linear-gradient(180deg, #3499f2 0%, #287de5 100%)",
        boxShadow: "0 8px 16px rgba(42, 139, 230, 0.28)",
        "& h1": {
            margin: 0,
            fontFamily: "Georgia, 'Times New Roman', serif",
            fontSize: "27px",
            lineHeight: 1.2,
            fontWeight: 700,
            letterSpacing: 0,
        },
    },
    cardBody: {
        marginTop: "-6px",
        padding: "0 22px 30px",
        "& .MuiFormControl-root": {
            height: "58px",
            margin: "0 0 8px",
            paddingTop: 0,
        },
        "& .MuiInput-root": {
            height: "48px",
            display: "flex",
            alignItems: "flex-end",
        },
        "& .MuiInputBase-input": {
            height: "22px",
            padding: "18px 0 7px",
            lineHeight: "22px",
            background: "transparent",
            boxSizing: "content-box",
        },
        "& .MuiInputBase-input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px #fff inset",
            WebkitTextFillColor: "#243b5a",
            caretColor: "#243b5a",
        },
        "& .MuiInputAdornment-positionEnd": {
            height: "48px",
            maxHeight: "48px",
            marginLeft: "10px",
            alignItems: "center",
        },
        "& .MuiSvgIcon-root, & .material-icons": {
            fontSize: "24px",
            lineHeight: "24px",
        },
        "& label": {
            color: "#7f8ba8 !important",
            fontSize: "11px",
            transform: "translate(0, 25px) scale(1)",
            transformOrigin: "top left",
        },
        "& label.MuiInputLabel-shrink": {
            transform: "translate(0, 7px) scale(0.75)",
        },
        "& input": {
            color: "#243b5a",
            fontSize: "13px",
        },
    },
    resetButton: {
        width: "100%",
        height: "36px",
        margin: "24px 0 0 !important",
        padding: "0 !important",
        borderRadius: "6px !important",
        background: "#2f8de9 !important",
        color: "#fff !important",
        fontSize: "10px !important",
        fontWeight: "700 !important",
        boxShadow: "none !important",
        "&:hover,&:focus": {
            background: "#247bd0 !important",
            color: "#fff !important",
        },
        "&:disabled": {
            background: "#70afea !important",
            color: "#fff !important",
            opacity: "1 !important",
        },
    },
    inputIconsColor: {
        color: "#6f7480",
    },
    errorContainer: {
        color: "#d32f2f",
        minHeight: "48px",
        fontSize: "11px",
        lineHeight: 1.35,
        textAlign: "center",
    },
    successMessage: {
        color: "#2e7d32",
    },
    footer: {
        position: "absolute",
        left: "14%",
        bottom: "18px",
        color: "#7181a8",
        fontSize: "12px",
        "& span": {
            color: "#6f7788",
        },
        "& strong": {
            color: "#243b5a",
        },
        [theme.breakpoints.down("sm")]: {
            position: "static",
            margin: "60px 24px 20px",
            textAlign: "center",
        },
    },
});

export default resetPasswordStyle;
